import React from 'react';
import "../template-file-css/document-file-template.css";


export const GHP_IFIOrderForServicesMedical = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='GHP_IFIOrderForServicesMedical' className='file-pdf-document'>
            <div className='file-template'>


                <table>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader w-375;">Start Date</span>
                            <input type='date' id="txtStartDate" name="txtStartDate" className="add-only " />
                            <span className='view-only txtStartDate'></span>
                        </td>
                        <td className="w-375">
                            <span className="eleHeader w-375;">End Date</span>
                            <input type='date' id="txtEndDate" name="txtEndDate" className="add-only " />
                            <span className='view-only txtEndDate'></span>
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className="w-600">
                            <span className="eleHeader w-600;">
                                Services To Be Ordered: (Physicians, Physician's Assistants and APRNs may order any service)
                            </span>
                        </td>
                        <td className="w-150">
                            <span className="eleHeader w-150;">Check If Service Needed</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-600">
                            <b>Diagnostic Assessment </b>
                            (U3, U2, or U1 may order this service) <br />Codes: 90791, 90792
                        </td>
                        <td className="w-150 text-center">
                            <input type="checkbox" id="cb_1" name="cb_1" className="add-only" value="1" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-600">
                            <b>Medication Management</b>
                            (Physicians, Physician's Assistants and APRNs may order this service)<br />
                            Codes: H2019, H0020, 96372
                        </td>
                        <td className="w-150 text-center">
                            <input type="checkbox" id="cb_2" name="cb_2" className="add-only" value="1" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-600">
                            <b>Nursing Assessment and Health Services </b>
                            (Physicians, Physician's Assistants and APRNs order this service)<br />
                            Codes: T1001, T1002, T1003, 96150, 96151
                        </td>
                        <td className="w-150 text-center">
                            <input type="checkbox" id="cb_3" name="cb_3" className="add-only" value="1" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-600">
                            <b>Psychiatric Treatment/Evaluation and Management</b>
                            (Physicians, Physician's Assistants and APRNs may order this service)<br />
                            99201, 99202, 99203, 99204, 99204, 99205, 90833, 90836, 99211, 99212, 99213, 99214, 99215
                        </td>
                        <td className="w-150 text-center">
                            <input type="checkbox" id="cb_4" name="cb_4" className="add-only" value="1" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-600">
                            <b>Psychological Testing</b>
                            (U3, U2, or U1 may order this service) <br />
                            Codes: 96101, 96102
                        </td>
                        <td className="w-150 text-center">
                            <input type="checkbox" id="cb_5" name="cb_5" className="add-only" value="1" />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className="w-300 signature">&nbsp;</td>
                        <td className="w-300 signature">&nbsp;</td>
                        <td className="w-150 signature">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-300 small"> Print Name Physician/MD </td>
                        <td className="w-300 small"> Signature Physician/MD</td>
                        <td className="w-150 small"> Date</td>
                    </tr>
                    <tr>
                        <td className="w-300 signature">&nbsp;</td>
                        <td className="w-300 signature">&nbsp;</td>
                        <td className="w-150 signature">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-300 small"> Print Name APRN </td>
                        <td className="w-300 small"> Signature APRN</td>
                        <td className="w-150 small"> Date</td>
                    </tr>
                    <tr>
                        <td className="w-300 signature">&nbsp;</td>
                        <td className="w-300 signature">&nbsp;</td>
                        <td className="w-150 signature">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-300 small"> Print Name Psychologist </td>
                        <td className="w-300 small"> Signature Psychologist</td>
                        <td className="w-150 small"> Date</td>
                    </tr>
                    <tr>
                        <td className="w-300 signature">&nbsp;</td>
                        <td className="w-300 signature">&nbsp;</td>
                        <td className="w-150 signature">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-300 small"> Print Name Licensed Clinician </td>
                        <td className="w-300 small"> Signature Licensed Clinician</td>
                        <td className="w-150 small"> Date</td>
                    </tr>
                </table>
            </div>
        </form>
    )
}